import { Component, ElementRef, Input, ViewChild, ViewEncapsulation, AfterViewInit, HostListener, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { AppService } from "src/app/app.service";
import { DhlFormControlEventData } from "../../dhl-form/models/dhl-form-control-event-data";
import { Router } from '@angular/router';
import { DhlFormControlEvent } from "../../dhl-form/models/dhl-form-control-event";
import { TranslateService } from '@ngx-translate/core';
import  { Constant }  from '../../constants/constants';
import { AlphaService } from "src/app/app-business-object-module/alpha.service";


@Component({
  selector: "app-generic-form-filter-v2",
  templateUrl: "./generic-form-filter-v2.component.html",
  styleUrls: ["./generic-form-filter-v2.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: {
    "(document:click)": "onWindowClick($event)",
  },
})
export class GenericFormFilterV2Component implements AfterViewInit {
  showFilters: boolean = false;
  filterApplied: boolean = false;
  hideShowFilterContainer:boolean = false;
  filterTerms = new Subject<any>();
  tempValCount = 0;
  valCount = 0;
  commonData = Constant;
  @Input() configData;
  @Input() frmGroup;

  @ViewChild('filter', {static: true, read: ElementRef}) filter: ElementRef;
  leftt: boolean;

  constructor(private appService: AppService, private _eref: ElementRef, private router: Router,public translate: TranslateService, private alphaService : AlphaService) { }
  form: any;
  ngAfterViewInit(){
    const {left, top}​​​​​ = this.filter.nativeElement.getBoundingClientRect();
    let elWidth = 530;
    if(left <  elWidth){​​​​​
      document.getElementById("formId").style.right = "auto";
      this.leftt= true;
     }​​​​​else{​​​​​
      document.getElementById("formId").style.right = '0';
      this.leftt= false; 
    }
    if(this.configData.hasOwnProperty("storeDataName")){
      if(sessionStorage.getItem(this.configData.storeDataName)){
        let localFilterForm = JSON.parse(sessionStorage.getItem(this.configData.storeDataName));
        // if(localFilterForm.vin || localFilterForm.shipper || localFilterForm.destinationLocationName || localFilterForm.pickupLocation || localFilterForm.businessSegment || localFilterForm.orderReverification
        //   || localFilterForm.inventoryType || localFilterForm.escalationReason || localFilterForm.holdReason || localFilterForm.pickupState || localFilterForm.orderExpedite){
          // for (let obj in this.form.value) {
            if (localFilterForm){
              this.form.patchValue(localFilterForm);
            }
          // }
        // }
        this.sendFilterToSource(null, null); //To avoid multiple service hits.
      }
    }
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'INIT');
    if(event){
      this.sendFilterToSource([event], null);
    }
  }
  displayFilterContainer($event,sCancel='')
  {
    $event.stopImmediatePropagation();
    if (this.showFilters) {
    this.hideShowFilterContainer = true;
    }
    if(sCancel == 'cancel')
    {
      this.showFilters=false;
      this.hideShowFilterContainer = false;

    }
  }
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  openFilterOptions($event) {
    this.hideShowFilterContainer=true;
    $event.stopImmediatePropagation();
    this.showFilters = !this.showFilters;
    if (this.showFilters) {
      this.filter.nativeElement.classList.add('active');
    }
    if (!this.filterApplied && this.form) {
      if (this.configData.customFilter !== true) { // to discuss with Alpha team
         this.form.reset();
      }
    }
  }
  onWindowClick(event) {
    let formId = document.getElementById('formId');
    if(formId && event.target && event.target.parentElement && event.target.parentElement.classList.contains("suggestion-item")){
      return;
    }
    if (formId && !formId.contains(event.target)) {
      this.showFilters = false;
    }
    if (!this._eref.nativeElement.contains(event.target)) {
      this.showFilters = false;
      this.filter.nativeElement.classList.remove('active');
    }
  }

  // setFormFields() {
  //   if (this.form) {
  //     if (this.configData.customFilter === true) {
  //         this.customFilterSetForm();
  //     }
  //   }
  // }

  getForm(event) {
    this.form = event;
   // this.setFormFields(); // to discuss with Alpha team
  }

  sendFilterToSource(events, userEvent) {
    if(events){
      events = events;
    } else {
      events = this.configData.events;
    }
    let sourceData, queryString ='';
    // if (this.configData.customFilter === true) { // to discuss with Alpha team
    //   let currentURL = this.router.url;
    //   sourceData = this.form.value;
    //   for (let obj in sourceData) {
    //     localStorage.setItem(currentURL + obj, sourceData[obj]);
    //   }
    // } else {
      sourceData = this.form.value;
      queryString = this.generateQueryString();
   // }

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    let formValue = JSON.parse(JSON.stringify(this.form.value));
    if(filterObj) {
      if (!filterObj?.searchString) {
        filterObj.searchString = filterObj?.SearchBox;
      }
      sourceData = this.alphaService.cloneUnMatchedKeys(filterObj, formValue);
      if(this.alphaService.getFilteredObject('LOCATION')) {
        let locationObj = this.alphaService.getFilteredObject('LOCATION');
        formValue = this.alphaService.cloneMatchedKeys(locationObj, formValue);
      }
      this.alphaService.setFilteredObject('setFiltersValues', { ...filterObj, ...formValue });
    } 

    let eventData: DhlFormControlEventData = {
      event: events[0].event,
      eventData: events[0],
      action: events[0].action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: {value: sourceData, queryString: queryString },
    };
    if(this.configData.hasOwnProperty("storeDataName")){
      sessionStorage.setItem(this.configData.storeDataName, JSON.stringify(sourceData));
    }
    eventData['userEvent'] = userEvent;
    this.appService._commonComponentSubject.next(eventData);
    this.showFilters = false;
    this.hideShowFilterContainer=false;
    this.filterApplied = true;
    this.setFormFilterCount();
  }

  setFormFilterCount(){
    this.tempValCount = 0;
    for (let cltr in this.form.controls) {
      if (this.configData.excludedControls && !this.configData.excludedControls[cltr]) {
        if ((Array.isArray(this.form.controls[cltr].value) && this.form.controls[cltr].value.length != 0) || !!this.form.controls[cltr].value) {
          if (this.appService._components[cltr].selectedValues != this.translate.instant(this.commonData.Filter_Popup_Status_All )  && this.form.controls[cltr].value.length >= 1) {
            this.tempValCount++;
          }
        }
      }
    };


    this.valCount = Object.values(this.form.value).filter(key => !!key).length;
  }

  // customRetainingForm() {  // to discuss with Alpha team
  //   if(this.form){
  //   for (let obj in this.form.value) {
  //     localStorage.setItem(this.router.url + obj, this.form.value[obj]);
  //       this.form.get(obj).setValue(this.form.value[obj])

  //     }
  //   }
  // }

  customFilterSetForm() {

    let currentURL = this.router.url;
    if (localStorage.getItem('filterCurrenturl') == currentURL) {
      for (let obj in this.form.value) {
        if (localStorage.getItem(currentURL + obj))
          this.form.get(obj).setValue(localStorage.getItem(currentURL + obj))
      }
    }

  }

  generateQueryString(){
    let queryString = '';
    if (this.form) {
      let formData = this.form.value;
      for (let obj in formData) {
        if(this.form.get(obj).value){
          let formValue = (this.form.get(obj).value.value !== null && this.form.get(obj).value.value !== undefined ) ? this.form.get(obj).value.value : encodeURIComponent(this.form.get(obj).value);
          if(formValue === "Yes"){
            formValue = true;
          }else if(formValue === "No"){
            formValue = false;
          }
          queryString += '&' + obj + '=' + formValue;
        }
      }
    }
    return queryString;
  }


  clearFilters(userEvent,action = '') {
    if (action !== 'reset') {
    sessionStorage.removeItem(this.configData.storeDataName);
    this.form.reset();
    // Object.keys(this.form.controls).forEach(field => {
    for (let field in this.form.controls) {
      const control = this.form.get(field);
      if (this.appService._components[field].configData.component == 'DATEPICKER_V2') {
        this.appService._components[field].filterDate = this.translate.instant(Constant.Filter_Popup_Status_All);
      } if (this.appService._components[field].configData.component == 'FILTER_V2') {
        let placeholder = this.appService._components[field].configData.placeHolder || this.appService._components[field].configData.placeholder;
        if (typeof placeholder === 'string') {
          placeholder = this.translate.instant(placeholder);
        }
        this.appService._components[field].selectedOption(placeholder, true);
      }
      control['secondaryText'] = "";
    }
    // });
    this.showFilters = false;
    setTimeout(()=>{
    this.sendFilterToSource(null, userEvent);
    },500)
    this.filterApplied = false;
  }
 }
}
